import hwActApi from '@/config/hwActApi'

export default {
  namespaced: true,
  state: {
    activityInfo: null,
    commonConfig: null,
  },
  mutations: {
    SET_ACTIVITY_INFO(state, info) {
      state.activityInfo = info
    },
    SET_COMMON_CONFIG(state, info) {
      state.commonConfig = info
    },
  },
  actions: {
    async fetchActivityInfo({ commit }, params) {
      const res = await hwActApi.getActivityInfo(params)
      commit('SET_ACTIVITY_INFO', res)
      return res
    },
    async fetchCommonConfig({ commit }, params) {
      const res = await hwActApi.getCommonConfig(params)
      commit('SET_COMMON_CONFIG', res)
      return res
    },
  },
}
